import {
  createContext,
  useContext,
  useState,
  useCallback,
  useMemo,
  type ReactNode,
} from 'react';

/** Bump after onboarding checklist or marina data changes so the sidebar can re-evaluate “show setup link”. */
interface OnboardingNavRefreshValue {
  bump: () => void;
  tick: number;
}

const OnboardingNavRefreshContext = createContext<OnboardingNavRefreshValue | null>(null);

export function OnboardingNavRefreshProvider({ children }: { children: ReactNode }) {
  const [tick, setTick] = useState(0);
  const bump = useCallback(() => setTick((n) => n + 1), []);
  const value = useMemo(() => ({ bump, tick }), [bump, tick]);
  return (
    <OnboardingNavRefreshContext.Provider value={value}>{children}</OnboardingNavRefreshContext.Provider>
  );
}

export function useOnboardingNavRefresh(): OnboardingNavRefreshValue {
  const v = useContext(OnboardingNavRefreshContext);
  return useMemo(() => v ?? { bump: () => {}, tick: 0 }, [v]);
}
